import {
  setupCodeBlockCopyButtons,
  setupExternalLinkHandlers,
  renderMath,
} from "../../../core";

export function applyBubbleHtml(rootElement, html = "") {
  if (!rootElement) {
    return;
  }

  rootElement.innerHTML = html || "";
  setupCodeBlockCopyButtons(rootElement);
  setupExternalLinkHandlers(rootElement);
  renderMath(rootElement);
}
